<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.8376 10.1C7.28064 10.1 6.7465 9.87875 6.35267 9.48492C5.95885 9.0911 5.7376 8.55695 5.7376 8C5.7376 7.44305 5.95885 6.9089 6.35267 6.51508C6.7465 6.12125 7.28064 5.9 7.8376 5.9C8.39455 5.9 8.9287 6.12125 9.32252 6.51508C9.71635 6.9089 9.9376 7.44305 9.9376 8C9.9376 8.55695 9.71635 9.0911 9.32252 9.48492C8.9287 9.87875 8.39455 10.1 7.8376 10.1ZM12.2956 8.582C12.3196 8.39 12.3376 8.198 12.3376 8C12.3376 7.802 12.3196 7.604 12.2956 7.4L13.5616 6.422C13.6756 6.332 13.7056 6.17 13.6336 6.038L12.4336 3.962C12.3616 3.83 12.1996 3.776 12.0676 3.83L10.5736 4.43C10.2616 4.196 9.9376 3.992 9.5596 3.842L9.3376 2.252C9.3136 2.108 9.1876 2 9.0376 2H6.6376C6.4876 2 6.3616 2.108 6.3376 2.252L6.1156 3.842C5.7376 3.992 5.4136 4.196 5.1016 4.43L3.6076 3.83C3.4756 3.776 3.3136 3.83 3.2416 3.962L2.0416 6.038C1.9636 6.17 1.9996 6.332 2.1136 6.422L3.3796 7.4C3.3556 7.604 3.3376 7.802 3.3376 8C3.3376 8.198 3.3556 8.39 3.3796 8.582L2.1136 9.578C1.9996 9.668 1.9636 9.83 2.0416 9.962L3.2416 12.038C3.3136 12.17 3.4756 12.218 3.6076 12.17L5.1016 11.564C5.4136 11.804 5.7376 12.008 6.1156 12.158L6.3376 13.748C6.3616 13.892 6.4876 14 6.6376 14H9.0376C9.1876 14 9.3136 13.892 9.3376 13.748L9.5596 12.158C9.9376 12.002 10.2616 11.804 10.5736 11.564L12.0676 12.17C12.1996 12.218 12.3616 12.17 12.4336 12.038L13.6336 9.962C13.7056 9.83 13.6756 9.668 13.5616 9.578L12.2956 8.582Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconSettings",
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
